import { render, staticRenderFns } from "./CableEdges.vue?vue&type=template&id=637faeb4&scoped=true"
import script from "./CableEdges.vue?vue&type=script&lang=js"
export * from "./CableEdges.vue?vue&type=script&lang=js"
import style0 from "./CableEdges.vue?vue&type=style&index=0&id=637faeb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637faeb4",
  null
  
)

export default component.exports